import React from 'react';
import MiscContent from './MiscContent';

export default () => <MiscContent
title='404.'
subtitle='page not found.'
/>;